<template>
  <div v-if="show">
    <b-card title="Usuário" header-tag="header" footer-tag="footer">
      <template v-if="emptyInstance">
        <div slot="header" class="row mb-0 align-items-right">
          <div class="col-12 text-right ">
            <div class="switch-container">
              <span class="switch-label mr-1">
                Ativar e Autorizar
              </span>

              <toggle-button class="mb-0"
                v-model="form._authorized"
                :width="70"
                :height="25"
                :labels="{ checked: 'SIM', unchecked: 'NÃO' }"/>
            </div>
          </div>
        </div>
      </template>

      <div class="row">
        <b-form-group class="col-12 col-md-4"
          label="Perfil"
          label-for="roles"
          description="Os dados do usuário variam conforme o o perfil adotado">

          <multiselect v-model="selectedRole"
            @select="updateForm('role_id', arguments[0])"
            :showLabels="false"
            :allowEmpty="false"
            :options="roles"
            label="name"
            placeholder="Selecione a perfil"
            track-by="id">

            <template slot="clear" slot-scope="props">
              <div class="multiselect__clear"
                v-if="selectedRole"
                @mousedown.prevent.stop="selectedRole = null">

                <i class="fa fa-times"></i>
              </div>
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group class="col-12 col-md-4 is-valid"
          label="Nome Completo"
          label-for="name"
          description="">

          <b-form-input id="name"
            type="text"
            v-model="form.name"
            required
            placeholder="Nome Completo"
            :class="{
              'is-invalid': submitted && form.errors.has('name'),
              'is-valid': submitted && !form.errors.has('name')
            }"></b-form-input>
        </b-form-group>

        <b-form-group class="col-12 col-md-4"
          label="Email"
          label-for="email"
          description="">

          <b-form-input id="email"
            type="text"
            v-model="form.email"
            placeholder="Email"
            :class="{
              'is-invalid': submitted && form.errors.has('email'),
              'is-valid': submitted && !form.errors.has('email')
            }"></b-form-input>
        </b-form-group>

        <div class="col-12 text-right" v-show="instance.id">
          <a href="#" @click.prevent.stop="togglePassword">
            <small>{{ updatePassword ? 'Ocultar' : 'Alterar Senha' }}</small>
          </a>
        </div>

        <template v-if="updatePassword">
          <b-form-group class="col-12 col-md-4"
            label="Senha"
            label-for="password"
            :description="instance.id ? 'Apenas preencha os campos de senha se você quiser atualiza-la' : ''">

            <b-form-input id="password"
              type="password"
              v-model="form.password"
              placeholder="***"
              :class="{
                'is-invalid': submitted && form.errors.has('password'),
                'is-valid': submitted && !form.errors.has('password')
              }"></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 col-md-4"
            label="Confirmação Senha"
            label-for="password_confirmation"
            description="">

            <b-form-input id="password_confirmation"
              type="password"
              v-model="form.password_confirmation"
              placeholder="***"
              :class="{
                'is-invalid': submitted && form.errors.has('password'),
                'is-valid': submitted && !form.errors.has('password')
              }"></b-form-input>
          </b-form-group>
        </template>
      </div>

      <template v-if="showAddress">
        <hr>

        <div class="row" v-if="get(selectedRole, 'slug', false) === 'process'">
          <b-form-group class="col-12 col-md-4"
            label="Processo"
            label-for="profile[process_id]">

            <multiselect v-model="selectedProcess"
              @select="updateForm('profile.process_id', arguments[0])"
              :allowEmpty="true"
              :options="processes"
              label="company_name"
              placeholder="Selecione o processo"
              :showLabels="false"
              track-by="id"
              :class="{
                'is-invalid': submitted && form.errors.has('profile.process_id'),
                'is-valid': submitted && !form.errors.has('profile.process_id')
              }">

              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear"
                  v-if="selectedProcess"
                  @mousedown.prevent.stop="selectedProcess = null">

                  <i class="fa fa-times"></i>
                </div>
              </template>
            </multiselect>
          </b-form-group>

          <b-form-group class="col-12 col-md-4"
            label="Documento (CNPJ)"
            label-for="document">

            <b-form-input id="document"
              type="text"
              v-model="form.document"
              placeholder="CNPJ"
              v-mask="'##.###.###/####-##'"
              :class="{
                'is-invalid': submitted && form.errors.has('document'),
                'is-valid': submitted && !form.errors.has('document')
              }"></b-form-input>
          </b-form-group>

          <b-form-group class="col-12 col-md-4"
            label="Telefone"
            label-for="phone_number">

            <b-form-input id="phone_number"
              type="text"
              v-model="form.phone_number"
              placeholder="+55 (XX) XXXXX-XXXX"
              v-mask="['+XX (##) ####-####', '+XX (##) #####-####']"
              :class="{
                'is-invalid': submitted && form.errors.has('phone_number'),
                'is-valid': submitted && !form.errors.has('phone_number')
              }"></b-form-input>
          </b-form-group>
        </div>

        <template v-if="get(selectedRole, 'slug', false) === 'attorney'">
          <div class="row">
            <b-form-group class="col-12 col-sm-6"
              label="Documento (OAB)"
              label-for="document">

              <b-form-input id="document"
                type="text"
                v-model="form.document"
                placeholder="OAB..."
                :class="{
                  'is-invalid': submitted && form.errors.has('document'),
                  'is-valid': submitted && !form.errors.has('document')
                }"></b-form-input>
            </b-form-group>

            <b-form-group class="col-12 col-sm-6"
              label="Telefone"
              label-for="phone_number">

              <b-form-input id="phone_number"
                type="text"
                v-model="form.phone_number"
                placeholder="+55 (XX) XXXXX-XXXX"
                v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                :class="{
                  'is-invalid': submitted && form.errors.has('phone_number'),
                  'is-valid': submitted && !form.errors.has('phone_number')
                }"></b-form-input>
            </b-form-group>
          </div>

          <div class="row">
            <h6 class="col-12">Dados do Cliente</h6>

            <b-form-group class="col-12 col-sm-4"
                label="Tipo"
                label-for="profile[client_type]">

                <multiselect v-model="selectedEntityType"
                  @select="updateForm(profileEntityType, arguments[0])"
                  :options="entityTypes"
                  :searchable="false"
                  :close-on-select="false"
                  :allow-empty="false"
                  :show-labels="false"
                  track-by="value"
                  label="label"
                  placeholder="Selecione o Tipo" />
              </b-form-group>

              <b-form-group class="col-12 col-sm-4"
                label="Nome"
                label-for="profile[client_name]">

                <b-form-input id="profile[client_name]"
                  type="text"
                  v-model="form.profile.client_name"
                  placeholder="XPTO ltda"
                  :class="{
                    'is-invalid': submitted && form.errors.has('profile[client_name]'),
                    'is-valid': submitted && !form.errors.has('profile[client_name]')
                  }"></b-form-input>
              </b-form-group>

              <b-form-group class="col-12 col-sm-4"
                :label="get(selectedEntityType, 'value', 1) === 1 ? 'CPF' : 'CNPJ'"
                label-for="profile[client_document]">

                <b-form-input id="profile[client_document]"
                  type="text"
                  v-model="form.profile.client_document"
                  :placeholder="get(selectedEntityType, 'value', 1) === 1 ? '000.000.000-00' : '00.000.000/0000-00'"
                  v-mask="documentMask"
                  :class="{
                    'is-invalid': submitted && form.errors.has('profile[client_document]'),
                    'is-valid': submitted && !form.errors.has('profile[client_document]')
                  }"></b-form-input>
              </b-form-group>
          </div>
        </template>

        <template v-if="get(selectedRole, 'slug', false) === 'creditor'">
          <div class="row">
            <b-form-group class="col-12 col-sm-6 col-lg-3"
              label="Tipo"
              label-for="profile[entity_type]">

              <multiselect v-model="selectedEntityType"
                @select="updateForm(profileEntityType, arguments[0])"
                :options="entityTypes"
                :searchable="false"
                :allow-empty="false"
                :close-on-select="false"
                :show-labels="false"
                track-by="value"
                label="label"
                placeholder="Selecione o Tipo" />
            </b-form-group>

            <b-form-group class="col-12 col-sm-6 col-lg-3"
              :label="get(selectedEntityType, 'value', 1) === 1 ? 'CPF' : 'CNPJ'"
              label-for="document">

              <b-form-input id="document"
                type="text"
                v-model="form.document"
                :placeholder="get(selectedEntityType, 'value', 1) === 1 ? '000.000.000-00' : '00.000.000/0000-00'"
                v-mask="documentMask"
                :class="{
                  'is-invalid': submitted && form.errors.has('document'),
                  'is-valid': submitted && !form.errors.has('document')
                }"></b-form-input>
            </b-form-group>

            <b-form-group class="col-12 col-sm-6 col-lg-3"
              label="Telefone"
              label-for="phone_number">

              <b-form-input id="phone_number"
                type="text"
                v-model="form.phone_number"
                placeholder="+XX (XX) XXXXX-XXXX"
                v-mask="['+## (##) ####-####', '+## (##) #####-####']"
                :class="{
                  'is-invalid': submitted && form.errors.has('phone_number'),
                  'is-valid': submitted && !form.errors.has('phone_number')
                }"></b-form-input>
            </b-form-group>

            <b-form-group class="col-12 col-sm-6 col-lg-3"
              label="Advogado"
              label-for="profile[attorney_name]">

              <b-form-input id="profile[attorney_name]"
                type="text"
                v-model="form.profile.attorney_name"
                placeholder="XPTO"
                :class="{
                  'is-invalid': submitted && form.errors.has('profile[attorney_name]'),
                  'is-valid': submitted && !form.errors.has('profile[attorney_name]')
                }"></b-form-input>
            </b-form-group>
          </div>
        </template>
      </template>

      <slot v-else name="footer"></slot>
    </b-card>

    <b-card v-if="instance.bank_accounts" title="Dados bancários">
      <datatable :entity="bankAccountEntity"
        :http="bankAccountHttp"
        :card="false"
        :filter="{ user_id: instance.id }">
      </datatable>
    </b-card>

<!--     <b-card v-if="instance.bank_account">
      <b-row>
        <b-col>
          <h5>Dados Bancários</h5>

          <b>Banco</b> {{ instance.bank_account.bank }} <br>
          <b>Agência</b> {{ instance.bank_account.agency }} <br>
          <b>Conta</b> {{ instance.bank_account.account_number }} <br>
        </b-col>

        <b-col>
          <h5>Favorecido</h5>

          <span v-if="instance.bank_account.same_person">
            (Mesma pessoa)
          </span>

          <template v-else>
            <b>Nome</b> {{ instance.bank_account.favored_name }} <br>
            <b>Tipo</b> {{ instance.bank_account.favored_type }} <br>
            <b>Documento</b> {{ instance.bank_account.favored_document }} <br>
            <template v-if="get(instance.bank_account, '_links', false)">
              <b>Procuração</b>&nbsp;

              <a :href="get(instance.bank_account, '_links.download', '#!')" >
                <i class="fa fa-download"></i> Baixar
              </a>
            </template>
          </template>
        </b-col>
      </b-row>

      <b-row v-if="instance.bank_account.observations">
        <b-col>
          <p>
            <b>Observações</b> {{ instance.bank_account.observations }}
          </p>
        </b-col>
      </b-row>
    </b-card> -->

    <b-card v-if="showAddress" title="Endereço" header-tag="header" footer-tag="footer">
      <address-fields :form="form"></address-fields>
      <slot name="footer"></slot>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isEmpty, get, set, merge, clone, isArray, isObject } from 'lodash'
import { resolveHTTP } from '@/services/api'
import { blBankAccounts } from '@/_entities'

export default {
  props: {
    form: {
      type: [Object],
      required: true
    },

    submitted: {
      type: Boolean,
      default: false
    },

    instance: {
      type: Object,
      default () {
        return {
          roles: [{}],
          avatar: []
        }
      }
    },

    http: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      // BankAccounts
      bankAccountEntity: blBankAccounts,
      bankAccountHttp: blBankAccounts.api || resolveHTTP(blBankAccounts.url),

      selectedEntityType: null,
      entityTypes: [
        { value: 1, label: 'Pessoa Física' },
        { value: 2, label: 'Pessoa Jurídica' }
      ],

      locks: {
        processes: true,
        categories: true
      },

      media: {},

      updatePassword: false,

      empty: {
        name: '',
        email: '',
        password: '',
        document: '',
        phone_number: '',
        role: '',
        password_confirmation: '',
        profile: {},
        address: {},
        roles: [{}],
        media_ids: [],
        _authorized: true
      },

      selectedRole: {},
      roles: [],

      selectedProcess: null,
      processes: [],

      show: false
    }
  },

  watch: {
    '$props': {
      handler: function (newProps, oldProps) {
        if (!get(newProps, 'form.role_id', false)) {
          this.selectedRole = null
          this.form.role = ''
        }

        if (!this.form.role && get(newProps, 'form.role_id', false)) {
          set(this.form, 'roles', [get(this.selectedRole, 'id', null)])
          this.form.role = get(this.selectedRole, 'slug', '')
        }

        if (this.selectedProcess && !get(newProps, 'form.profile.process_id', false)) {
          this.selectedProcess = null
        }
      },
      deep: true
    },

    selectedProcess () {
      set(this.form, 'profile.process_id', get(this.selectedProcess, 'id', null))
    },

    selectedRole () {
      set(this.form, 'roles', [get(this.selectedRole, 'id', null)])
      this.form.role = get(this.selectedRole, 'slug', '')
    }
  },

  computed: {
    ready () {
      return !(this.locks.roles || this.locks.processes)
    },

    ...mapGetters({
      loggedUser: 'auth/user'
    }),

    showAddress () {
      return get(this.selectedRole, 'slug', 'admin') !== 'admin'
    },

    emptyInstance () {
      return get(this.instance, 'id', null) === null
    },

    mediaUrl () {
      return this.http.routes.uploadMedia(this.instance.id)
    },

    mediaInstance () {
      if (!isEmpty(this.media)) {
        return this.media
      }

      if (!isEmpty(this.instance.avatar_url)) {
        return { url: this.instance.avatar_url }
      }

      return {}
    },

    profileEntityType () {
      return get(self, 'selectedRole.slug', false) === 'attorney' ? 'client_type' : 'entity_type'
    },

    documentMask () {
      if (get(this.selectedEntityType, 'value', 1) === 1) {
        return '###.###.###-##'
      }

      return '##.###.###/####-##'
    }
  },

  methods: {
    get,

    ...mapActions({
      fetchUser: 'auth/fetchUser'
    }),

    updateForm (path, value) {
      set(this.form, path, value ? value.id : null)
    },

    handleUploadMedia (file, response, progress) {
      // 1. we will set the new media id on the form for latter process
      this.form.media_ids = [response.id]

      // 2. Let's set the media on the source for the upload field
      this.media = response

      // If the user is the same loggedUser we will fetch again to reload the auth data
      if (this.instance.id === this.loggedUser.id) {
        this.fetchUser()
      }
    },

    togglePassword () {
      this.updatePassword = !this.updatePassword

      if (!this.updatePassword) {
        this.form.password = ''
        this.form.password_confirmation = ''
      }
    }
  },

  mounted () {
    this.$nextTick(() => { this.show = true })
  },

  created () {
    const self = this

    if (self.instance.id) {
      self.form.withData(self.instance).setInitialValues(merge(self.empty, self.instance))
      self.selectedRole = self.instance.roles.length ? self.instance.roles[0] : {}
    } else {
      self.updatePassword = true
      self.form.withData(clone(self.empty)).setInitialValues(clone(self.empty))
    }

    // Fixes the form
    let profile = get(self.form, 'profile', false)
    if (isArray(profile) || !isObject(profile)) {
      set(self.form, 'profile', {})
    }

    // Fixes the role
    self.form.roles = [get(self.selectedRole, 'id', null)]
    self.form.role_id = get(self.selectedRole, 'id', null)
    self.form.role = get(self.selectedRole, 'slug', null)

    // Lets grab the roles for the form
    resolveHTTP('/system/roles').index({ params: { _onepage: true } })
      .then(function (res) {
        self.roles = res.data.collection
        self.locks.roles = false

        self.selectedRole = self.form.role_id
          ? self.roles.find((o) => o.id === self.form.role_id)
          : null
      })

    resolveHTTP('/bl/processes').index({ params: { _onepage: true } })
      .then(function (res) {
        self.processes = res.data.collection
        self.locks.processes = false

        self.selectedProcess = get(self.form, 'profile.process_id', false)
          ? self.processes.find((o) => o.id === get(self.form, 'profile.process_id', false))
          : null
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/System/User.vue